// import firebase from "firebase";
// import db from "./db.js";
import { OlabUtils } from "./olabutils.js";

class OlabCstb {
  static info = {
    boxBar: "",
    boxBarStyle: "",
    box_id: "",
    box_type: "",
    seq: ""
  };

  constructor(boxID) {
    // OlabUtils.infoLog("OlabCstb.constructor() ...");
    this.cstb = this.createCstb(boxID);
    this.item = null;
  }

  createCstb(id) {
    const cc = {
      box_id: id,
      display_name: "Box " + id,
      box_type: "undefined",
      suffix: "",
      start: "--",
      range: "--",
      primer_type: "default",
      // template: "undefined",
      btn_color: "unset-color",
      btn_state: "" /* "disabled", */,
      use_seq_as_color: "text-light bg-secondary",
      configured: false,
      comp_olab_id: "",
      // item: null,
      seq: null,
      package_op: "combination",
      package_override: false
    };
    return cc;
  }

  set(cc) {
    this.cstb = cc.cstb;
    this.item = cc.item;
  }

  setItem(cartItems) {
    // OlabCstb.infoLog(this);
    if (this.cstb.comp_olab_id && cartItems != null) {
      // OlabUtils.infoLog("setItem: cartItems.length = " + cartItems.length);
      for (let i = 0; i < cartItems.length; i++) {
        const id = this.cstb.comp_olab_id;
        // OlabUtils.infoLog("Searching .... com_olab_id = " + id);
        if (id == cartItems[i].comp.olab_id) {
          // OlabUtils.infoLog("Found!!! olab_id = " + id);
          this.item = cartItems[i];
          break;
        }
      }
    }
  }

  unsetItem(cartItems) {
    this.cstb.start = "--";
    this.cstb.range = "--";
    this.cstb.btn_state = ""; /* "disabled" */
    this.cstb.configured = false;
    this.cstb.comp_olab_id = "";
    this.cstb.seq = null;
    this.cstb.package_op = "combination";
    this.cstb.package_override = false;
    this.cstb.primer_type = "default";
    // Look for cart item that matches item and restore counter values.
    for (let ii = 0; ii < cartItems.length; ii++) {
      if (cartItems[ii] === this.item) {
        cartItems[ii].comp.available_count++;
        cartItems[ii].comp.used_count--;
      }
    }
    this.item = null;
  }

  updateCartItem(index, cartItems) {
    if (this.item != null) {
      // Look for cart item that matches item and restore counter values.
      for (let ii = 0; ii < cartItems.length; ii++) {
        if (cartItems[ii] === this.item) {
          cartItems[ii].comp.available_count++;
          cartItems[ii].comp.used_count--;
        }
      }
    }
    // Set the newly assigned item
    let newItem = cartItems[index];
    this.cstb.display_name = this.cstb.suffix + newItem.display_name;
    this.cstb.btn_state = "";
    this.cstb.configured = true;
    this.cstb.comp_olab_id = newItem.comp.olab_id;
    this.item = newItem;
    cartItems[index].comp.available_count--;
    cartItems[index].comp.used_count++;
  }

  setBoxType(boxType, setName) {
    switch (boxType) {
      case "down_stream" /* Down Stream (D_) */:
        this.cstb.display_name = setName
          ? "Down Stream"
          : this.cstb.display_name;
        this.cstb.box_type = "down_stream";
        this.cstb.suffix = "D_";
        this.cstb.btn_color = "downstream-color-sm";
        this.cstb.use_seq_as_color = "text-light downstream-color";
        break;
      case "gene" /* Gene (G_) */:
        this.cstb.display_name = setName ? "Gene" : this.cstb.display_name;
        this.cstb.box_type = "gene";
        this.cstb.suffix = "G_";
        this.cstb.btn_color = "gene-color-sm";
        this.cstb.use_seq_as_color = "text-light gene-color";
        break;
      case "promoter" /* Promoter (P_) */:
        this.cstb.display_name = setName ? "Promoter" : this.cstb.display_name;
        this.cstb.box_type = "promoter";
        this.cstb.suffix = "P_";
        this.cstb.btn_color = "promoter-color-sm";
        this.cstb.use_seq_as_color = "text-light promoter-color";
        break;
      case "rbs" /* RBS (R_) */:
        this.cstb.display_name = setName ? "RBS" : this.cstb.display_name;
        this.cstb.box_type = "rbs";
        this.cstb.suffix = "R_";
        this.cstb.btn_color = "rbs-color-sm";
        this.cstb.use_seq_as_color = "text-light rbs-color";
        break;
      case "pgst" /* PGsT (W_) */:
        this.cstb.display_name = setName ? "PGsT" : this.cstb.display_name;
        this.cstb.box_type = "pgst";
        this.cstb.suffix = "W_";
        this.cstb.btn_color = "pgst-color-sm";
        this.cstb.use_seq_as_color = "text-light pgst-color";
        break;
      case "terminator" /* Terminator (T_) */:
        this.cstb.display_name = setName
          ? "Terminator"
          : this.cstb.display_name;
        this.cstb.box_type = "terminator";
        this.cstb.suffix = "T_";
        this.cstb.btn_color = "terminator-color-sm";
        this.cstb.use_seq_as_color = "text-light terminator-color";
        break;
      case "up_stream" /* Up Stream (U_) */:
        this.cstb.display_name = setName ? "Up Stream" : this.cstb.display_name;
        this.cstb.box_type = "up_stream";
        this.cstb.suffix = "U_";
        this.cstb.btn_color = "upstream-color-sm";
        this.cstb.use_seq_as_color = "text-light upstream-color";
        break;
      case "unset" /* unset */:
        this.cstb.display_name = "Box " + this.cstb.box_id;
        this.cstb.box_type = "undefined";
        this.cstb.suffix = "";
        this.cstb.btn_color = "unset-color";
        this.cstb.use_seq_as_color = "text-light bg-secondary";
        break;
    }

    // Reset box's configured
    this.cstb.configured = false;

    // Set box's states into info as status
    OlabCstb.info.boxBar = this.cstb.display_name;
    OlabCstb.info.box_type = this.cstb.box_type;
    OlabCstb.info.boxBarStyle = this.cstb.use_seq_as_color;
  }

  setSeq(seq) {
    this.cstb.seq = seq;
    OlabCstb.info.seq = this.cstb.seq;
  }

  static setInfoBox(cc) {
    // Set box's states into info as status
    OlabCstb.info.box_id = cc.cstb.box_id;
    OlabCstb.info.boxBar = cc.cstb.display_name;
    OlabCstb.info.box_type = cc.cstb.box_type;
    OlabCstb.info.boxBarStyle = cc.cstb.use_seq_as_color;
    OlabCstb.info.seq = cc.cstb.seq;
    if (cc.item && cc.item.seq && cc.item.seq.olab_type == "package") {
      let comps = cc.item.seq.comps;
      if (comps) {
        if (comps.length > 1) {
          OlabCstb.info.seq += " with " + comps.length + " items";
        } else {
          OlabCstb.info.seq += " with " + comps.length + " item";
        }
      } else {
        OlabCstb.info.seq += " with no item";
      }
    }
  }

  static resetInfoBox() {
    // Reset box's states into info as status
    OlabCstb.info.box_id = "";
    OlabCstb.info.boxBar = "";
    OlabCstb.info.box_type = "";
    OlabCstb.info.boxBarStyle = "";
    OlabCstb.info.seq = "";
  }

  static infoLog(cc) {
    OlabUtils.infoLog(" - cstb.box_id = " + cc.cstb.box_id);
    OlabUtils.infoLog(" - cstb.display_name = " + cc.cstb.display_name);
    OlabUtils.infoLog(" - cstb.box_type = " + cc.cstb.box_type);
    OlabUtils.infoLog(" - cstb.suffix = " + cc.cstb.suffix);
    OlabUtils.infoLog(" - cstb.start = " + cc.cstb.start);
    OlabUtils.infoLog(" - cstb.range = " + cc.cstb.range);
    OlabUtils.infoLog(" - cstb.primer_type = " + cc.cstb.primer_type);
    OlabUtils.infoLog(" - cstb.btn_color = " + cc.cstb.btn_color);
    OlabUtils.infoLog(" - cstb.btn_state = " + cc.cstb.btn_state);
    OlabUtils.infoLog(" - cstb.use_seq_as_color = " + cc.cstb.use_seq_as_color);
    OlabUtils.infoLog(" - cstb.configured = " + cc.cstb.configured);
    OlabUtils.infoLog(" - cstb.comp_olab_id = " + cc.cstb.comp_olab_id);
    OlabUtils.infoLog(" - cstb.seq = " + cc.cstb.seq);
    OlabUtils.infoLog(" - cstb.package_op = " + cc.cstb.package_op);
    OlabUtils.infoLog(" - cstb.package_override = " + cc.cstb.package_override);
    OlabUtils.infoLog(" - item = " + cc.item);
  }
}

export { OlabCstb };
